import React from 'react';
import { urlDocumentosPlugin } from 'src/parametros';

const NotFound = () => {
  return (
    <div className="container-fluid" style={{ paddingTop: '10%' }}>
      <div className="row justify-content-center">
        <div className="col-sm-4 align-self-center text-center">
          <img
            className="img-fluid"
            src={`${urlDocumentosPlugin}pagina_no_encontrada.png`}
            alt=""
          ></img>
        </div>
        <div className=" col-sm-8">
          <p
            style={{
              fontSize: '50px',
              fontWeight: 'bold',
              paddingTop: '20%',
            }}
          >
            Página no encontrada
          </p>
          <p>
            La url a la que intenta acceder es incorrecta. Por favor comuníquese con el
            administrador.{' '}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
